module.exports = __webpack_public_path__ + "img/Photo_1__East_Street_980_84_Hotel00001.91b008b9.jpg";